import { useState, useCallback } from 'react';

type ViewMode = 'form' | 'pdf';

/**
 * Hook for managing view mode state (form vs PDF)
 */
export const useViewMode = (initialMode: ViewMode = 'form') => {
  const [viewMode, setViewMode] = useState<ViewMode>(initialMode);

  /**
   * Toggle between form and PDF view modes
   */
  const toggleViewMode = useCallback(() => {
    setViewMode((prev) => (prev === 'form' ? 'pdf' : 'form'));
  }, []);

  /**
   * Set view mode to a specific value
   */
  const setMode = useCallback((mode: ViewMode) => {
    setViewMode(mode);
  }, []);

  return {
    viewMode,
    toggleViewMode,
    setMode,
    isFormMode: viewMode === 'form',
    isPdfMode: viewMode === 'pdf',
  };
};

export default useViewMode;
